var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 53,
    width: 53,
    height: 53,
    rx: 5,
    transform: "rotate(-90 0 53)",
    fill: "#8D8D8D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2994 17.9994L22.2798 20.137C22.1096 20.1976 18.3992 20.1859 17.9628 20.1605C17.3386 20.0959 16.7241 20.5164 16.4794 20.8117C16.0646 21.3104 16.002 21.6879 16.002 22.476C16.002 23.9181 16.002 25.3595 16.002 26.8002C18.0254 26.8002 37.7652 26.8549 37.9608 26.7767V21.9676C37.9403 21.5429 37.7729 21.1385 37.4873 20.8235C36.9002 20.1116 36.0978 20.1253 34.9315 20.1468C34.3914 20.1585 33.8473 20.1468 33.3053 20.1468C32.7925 20.1468 32.2035 20.1742 31.7006 20.1468C31.6399 19.8143 31.6869 18.901 31.6869 18.5098C31.6869 16.9452 30.8434 17.0215 29.773 17.0215H24.6849C24.2681 17.0215 23.4031 16.9726 23.0528 17.088C22.8505 17.1517 22.6712 17.273 22.5367 17.4369C22.4022 17.6009 22.3184 17.8004 22.2955 18.0111L22.2994 17.9994ZM23.8532 18.5861H30.1155V20.1155H23.8532V18.5861Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9432 34.0462C37.9843 33.0488 37.9589 32.0278 37.9569 31.0226C37.955 30.0173 37.9569 29.0141 37.9569 28.0069L29.7377 28.0166C29.7103 28.6659 29.8865 30.0897 29.5225 30.4809C29.2505 30.7703 28.8845 30.7292 28.4031 30.7292H25.6634C25.1722 30.7292 24.7886 30.7957 24.4892 30.5024C24.1898 30.209 24.2446 29.8922 24.2446 29.3974V27.9971H16.0078V33.8936C16.0084 34.1496 16.0607 34.4027 16.1616 34.638C16.2625 34.8732 16.4099 35.0857 16.5949 35.2626C17.3777 36.0234 18.6849 35.82 19.9843 35.82H35.771C36.3972 35.82 36.91 35.6851 37.2818 35.3526C37.5577 35.1081 37.955 34.6348 37.9471 34.0305L37.9432 34.0462Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4246 29.5323L28.5459 29.548L28.542 27.9854L25.4324 27.9893L25.4246 29.5323Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18.8571,
    fill: "white",
    transform: "translate(16 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationIcon);
export default __webpack_public_path__ + "static/media/designation_icon.f619e322e4ad5a9918c0302bb07f1669.svg";
export { ForwardRef as ReactComponent };